import statisticsIndividualPage from "./statisticsIndividualPage"

export default statisticsIndividualPage
